export function findParent<T>(object: T, parentProperty: string, predicate: (o: T) => any) {
	while (object && !predicate(object)) {
		object = (object as any)[parentProperty];
	}

	if (!object) {
		return null;
	}

	return object;
}

export function findInParents(object: Object, parentProperty: string, propertyToFind: string) {
	const parent = findParent(object, parentProperty, o => propertyToFind in o);

	if (!parent) {
		return null;
	}

	return (parent as any)[propertyToFind];
}
